import { SoundPaletteMap, SoundPalette, SoundRow, SoundMatrix } from "@components/common/launchpad";

export const firstMatrix: SoundRow[] = [
  [
    { nodeName: 'a7', sound: 'x3', color: '#EF56CE' },
    { nodeName: 'a8', sound: 'x2', color: '#EC3899' },
    { nodeName: 'a9', sound: 'x1', color: '#E91A64' },
  ],
  [
    { nodeName: 'a4', sound: 'x6', color: '#F489D0' },
    { nodeName: 'a5', sound: 'x5', color: '#F064A5' },
    { nodeName: 'a6', sound: 'x4', color: '#EE3E7B' },
  ],
  [
    { nodeName: 'a1', sound: 'x9', color: '#F9BBD2' },
    { nodeName: 'a2', sound: 'x8', color: '#F38FB2' },
    { nodeName: 'a3', sound: 'x7', color: '#F16294' },
  ],

]

const secondMatrix: SoundMatrix = [
  [
    { nodeName: 'b7', sound: 'b3', color: '#4470E0' },
    { nodeName: 'b8', sound: 'b2', color: '#2356AF' },
    { nodeName: 'b9', sound: 'b1', color: '#013B7D' }
  ],
  [
    { nodeName: 'b4', sound: 'b6', color: '#56A4E3' },
    { nodeName: 'b5', sound: 'b5', color: '#2B84BD' },
    { nodeName: 'b6', sound: 'b4', color: '#006396' }
  ],
  [
    { nodeName: 'b1', sound: 'b9', color: '#67D8E5' },
    { nodeName: 'b2', sound: 'b8', color: '#43BCD4' },
    { nodeName: 'b3', sound: 'b7', color: '#0090B5' }
  ],
]
const thirdMatrix: SoundMatrix = [
  [
    { nodeName: 'd7', sound: 'd3', color: '#44B7AC' },
    { nodeName: 'd8', sound: 'd2', color: '#22A992' },
    { nodeName: 'd9', sound: 'd1', color: '#009A78'},
  ],
  [
    { nodeName: 'd4', sound: 'd6', color: '#6FC5AD'  },
    { nodeName: 'd5', sound: 'd5', color: '#38BC94' },
    { nodeName: 'd6', sound: 'd4', color: '#00B27A' },
  ],
  [
    { nodeName: 'd1', sound: 'd9', color: '#99D3AD' },
    { nodeName: 'd2', sound: 'd8', color: '#70D09E' },
    { nodeName: 'd3', sound: 'd7', color: '#46CC8F'},
  ],
]

const fourthMatrix: SoundMatrix = [
  [
    { nodeName: 'x7', sound: 'a3', color: '#aaa3b1' },
    { nodeName: 'x8', sound: 'a2', color: '#b94eb2' },
    { nodeName: 'x9', sound: 'a1', color: '#c617b2' }
  ],
  [
    { nodeName: 'x4', sound: 'a6', color: '#d89e81' },
    { nodeName: 'x5', sound: 'a5', color: '#e15c7f' },
    { nodeName: 'x6', sound: 'a4', color: '#df2a89' }
  ],
  [
    { nodeName: 'x1', sound: 'a9', color: '#f9ce04' },
    { nodeName: 'x2', sound: 'a8', color: '#f87f2e' },
    { nodeName: 'x3', sound: 'a7', color: '#f6434c' }
  ],
]





const defaultSoundPalette: SoundPalette = {
  key: 'default',
  caption: 'Xylophone',
  matrix: firstMatrix
}

const secondSoundPalette: SoundPalette = {
  key: 'extra',
  caption: 'Bass',
  matrix: secondMatrix
}

const thirdSoundPalette: SoundPalette = {
  key: 'bass',
  caption: 'Drum',
  matrix: thirdMatrix
}
const fourthSoundPalette: SoundPalette = {
  key: 'Mixed',
  caption: 'Mixed',
  matrix: fourthMatrix
}
const soundPaletteMap: SoundPaletteMap = {
  default: defaultSoundPalette,
  extra: secondSoundPalette,
  bass: thirdSoundPalette,
  Mixed: fourthSoundPalette
}

export default soundPaletteMap;
